// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"196ffb04","373":"14c3264b","464":"013651d6","849":"14c3264b","858":"14c3264b","859":"14c3264b","872":"14c3264b"}[chunkId] + ".chunk.css";
};